module.exports = __webpack_public_path__ + "media/images/pro_subscription/partnership/v2/partenariat2-e2682770debb0adaaf4bb73ef2247fef.jpg";